/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo, useRef, useCallback, useContext } from "react";
import { Store } from "../Store/store";
import { API_URL, STATIC_URL, custom_axios } from "./Common";
import styled from "@emotion/styled";
import { Box, IconButton } from "@mui/material";
import { useDropzone } from "react-dropzone";
import ContentEditable from "react-contenteditable";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import Linkify from "react-linkify";
import ShowTimelineUserInfo from "./ShowTimelineUserInfo";
import ShowCommon from "../Common/ShowCommon";

const CommentContainer = styled("div")`
  padding-right: 8px;
  padding-left: 5px;
  display: flex;
  align-items: start;
  margin-bottom: 13px;
`;

const CommentContent = styled("div")`
  margin-left: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
`;

const CommentHeader = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const CommentHeaderName = styled("div")`
  font-size: 1rem;
  font-weight: 500;
`;
const CommentHeaderDate = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
`;

const CommentText = styled("div")`
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  font-size: 0.9rem;
`;

const CommentHeaderTitle = styled("div")`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3.5px 10px;
`;

const CommentHeaderTitleClose = styled(CloseIcon)`
  color: ${(props) => props.theme.palette.primary.contrastText};
`;

const Separator = styled("div")`
  width: 100%;
  height: 1px;
  background-color: #ddd;
`;

const CommentsList = styled(Box)`
  padding-top: 16px;
  overflow-y: auto;
`;

function ShowTimelineComment({
  timelineid,
  handleClose,
  handleClickOpen,
  handleMeClose,
  showuser,
  handleDeleteOpen,
  handleDeleteClose,
  showdeleteidex,
  open,
}) {
  const { state, hubConnection } = useContext(Store);
  const [lastcommentid, setlastcommentid] = useState(""); //最後のコメントID
  const [comments, setComments] = useState([]); //コメント一覧
  const [charSize, setCharSize] = useState(0); //コメント文字数

  const myRef = useRef(null);
  const [inputtext, setInputtext] = useState({ html: "" }); //コメント入力テキスト
  const { getRootProps, getInputProps } = useDropzone({ noClick: true });

  const CommentContainerRef = useRef(null); //コメントリストのref
  const [loadingMore, setLoadingMore] = useState(false); //ローディング状態

  const [lastFetchedId, setLastFetchedId] = useState(null); //スクロール無限ループ制御

  const MemoUserInfo = useMemo(() => {
    return <ShowTimelineUserInfo open={showuser.open} honbuid={showuser.honbuid} handleClose={handleMeClose} />;
  }, [showuser]);

  const DeleteCheck = useMemo(() => {
    return (
      <ShowCommon
        open={showdeleteidex.open}
        handleClose={handleDeleteClose}
        title="削除しますか？"
        handleCallBack={() => {
          handleDeleteComment(showdeleteidex.index);
          handleDeleteClose();
        }}
      ></ShowCommon>
    );
  }, [showdeleteidex]);

  const handleCommentSubmit = async (event) => {
    event.preventDefault();
    const trimmedComment = inputtext.html.trim();
    if (trimmedComment !== "") {
      const formattedMessage = trimmedComment.replace(/<br>/g, "\n");

      await hubConnection.invoke("InsertTimelineComment", timelineid, state.honbuid, formattedMessage);

      setInputtext({ html: "" });
    }
  };

  const handleDeleteComment = async (index) => {
    const Commentlist = [...comments];
    const deleteid = Commentlist[index].orderid;

    await hubConnection.invoke("DeleteTimelineComment", timelineid, state.honbuid, deleteid);

    Commentlist.splice(index, 1);
    setComments(Commentlist);
  };

  const handleKeyDown = (e) => {
    //let checked = localStorage.getItem("checkedEnter") == "1" ? true : false;
    let checked = false;
    const sendMes = () => {
      e.preventDefault();
      handleCommentSubmit(e);
    };
    // Enter押下
    if (e.which === 13) {
      // Ctrl
      if (e.ctrlKey && !e.shiftKey) {
        sendMes();
        // Shift
      } else if (!e.ctrlKey && e.shiftKey) {
        // 改行
        return false;
        // Ctrl, Shiftなし
      } else {
        // 「Enterで送信」チェックの有無
        if (checked) {
          sendMes();
        } else {
          // 改行
          return false;
        }
      }
    }
  };

  const fetchCommentData = useCallback(async (lastcommentid = "") => {
    if (comments.length > 0 && lastcommentid === lastFetchedId && lastFetchedId !== null) {
      return null;
    }

    const sql = `${API_URL}/GetTimelineComment?timelineid=${timelineid}&honbuid=${state.honbuid}&lastcommentid=${lastcommentid}`;

    const result = await custom_axios(sql);

    if (result.status === 401) {
      return null;
    } else if (result.status === 200) {
      setLastFetchedId(null);
      const formattedComments = result.data.comments.map((comment) => ({
        orderid: comment.orderid,
        name: comment.name,
        message: comment.message,
        input_date: comment.input_date,
        honbuid: comment.honbuid,
        fileno: comment.fileno,
        deleteicon: comment.deleteicon,
      }));
      setComments((prevComments) => {
        const filteredComments = formattedComments.filter(
          (newComment) => !prevComments.some((existingComment) => existingComment.orderid === newComment.orderid)
        );
        return prevComments.concat(filteredComments).sort((a, b) => b.orderid - a.orderid);
      });

      if (formattedComments.length > 0) {
        setlastcommentid(formattedComments[formattedComments.length - 1].orderid);
      }
    } else if (result.status === 204) {
      setLastFetchedId(lastcommentid);
      return null;
    }

    return null;
  }); //APIからコメントを取得

  const fetchMoreData = async () => {
    if (loadingMore || !comments || comments.length === 0) {
      return;
    }
    setLoadingMore(true);
    await fetchCommentData(lastcommentid);
    setLoadingMore(false);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          fetchMoreData();
        }
      },
      {
        threshold: 0.1, //再取得するまでの表示閾値
      }
    );

    if (CommentContainerRef.current) {
      observer.observe(CommentContainerRef.current);
    }
    return () => {
      if (CommentContainerRef.current) {
        observer.unobserve(CommentContainerRef.current);
      }
    };
  }, [fetchMoreData, CommentContainerRef]);

  useEffect(() => {
    async function fetchData() {
      setCharSize(0);
      await fetchCommentData();
    }
    fetchData();
  }, [open]);

  return (
    <Box height="100vh" display="flex" flexDirection="column">
      {MemoUserInfo}
      {DeleteCheck}

      <CommentHeaderTitle>
        コメント
        <IconButton aria-label="close" onClick={handleClose}>
          <CommentHeaderTitleClose />
        </IconButton>
      </CommentHeaderTitle>

      <CommentsList flexGrow={1}>
        {comments.map((comment, index) => (
          <CommentContainer key={index} ref={index === comments.length - 1 ? CommentContainerRef : null}>
            {/* <div className="member-content"> */}
            <img
              src={STATIC_URL + `/downloadAvatar?honbuid=${comment.honbuid}&fileno=${comment.fileno}&size=small`}
              width="30"
              height="30"
              alt=""
              className="member-image"
              onClick={() => handleClickOpen(comment.honbuid)}
            />
            {/* </div> */}
            <CommentContent>
              <CommentHeader>
                <CommentHeaderName>{comment.name}</CommentHeaderName>
                <CommentHeaderDate>
                  {comment.input_date}
                  {comment.deleteicon === "1" && (
                    <IconButton
                      aria-label="delete"
                      onClick={() => {
                        handleDeleteOpen(index);
                      }}
                      size="small"
                    >
                      <DeleteIcon fontSize="inherit" color="primary" />
                    </IconButton>
                  )}
                </CommentHeaderDate>
              </CommentHeader>

              <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => (
                  <a target={`_blank`} href={decoratedHref} key={key} rel="noopener noreferrer">
                    {decoratedText}
                  </a>
                )}
              >
                <CommentText>{comment.message}</CommentText>
              </Linkify>
            </CommentContent>
          </CommentContainer>
        ))}
      </CommentsList>

      <Separator />

      <div className="flex-div">
        <div
          {...getRootProps({ className: "message-box-wraper" })}
          style={{
            height: "auto",
            width: "70%",
            margin: "0 auto",
            paddingTop: "10px",
          }}
        >
          <input {...getInputProps()} />
          <ContentEditable
            translate="no"
            onPaste={(e) => {
              let imgs = [];
              for (var i = 0; i < e.clipboardData.items.length; i++) {
                // Skip content if not image
                if (e.clipboardData.items[i].type.indexOf("image") == -1) continue;
                // Retrieve image on clipboard as blob
                var blob = e.clipboardData.items[i].getAsFile();
                imgs.push(blob);
              }
              if (imgs.length > 0) {
                /* 画像データ貼り付け時 */
                //console.log("inputjs past元", blob);
                //document.execCommand("insertHTML", false, e.clipboardData);
              } else {
                /* テキスト貼り付け時 */
                e.preventDefault();
                var text = e.clipboardData.getData("text/plain");
                //console.log("inputjs past加工", text);
                document.execCommand("insertHTML", false, text.replace(/\r?\n/g, "<br>"));
              }
            }}
            className={"timelineeditablediv"}
            innerRef={myRef}
            html={inputtext.html}
            disabled={false}
            onChange={(e) => {
              let sendstr = myRef.current.innerHTML.replace(/<br>/g, "\n").replace(/<(?:.|)*?>/gm, "");
              setCharSize(sendstr.length);
              setInputtext({ html: e.target.value });
            }} // handle innerHTML change
            onKeyDown={(e) => handleKeyDown(e)}
          />
        </div>
        <div className="reservation-area-buttons" style={{ fontSize: "13px" }}>
          (文字: {charSize} / 1000)
        </div>

        <IconButton onClick={handleCommentSubmit} color="primary">
          <SendIcon />
        </IconButton>
      </div>
    </Box>
  );
}

export default ShowTimelineComment;
